exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[class*=input_input-form] {\n  font-size: 0.85rem;\n}\nspan[class*=label_input-label] {\n  font-size: 0.85rem;\n}\n/* 编辑区 */\n/* 舞台和角色区 */\n/* 同时控制造型里的角色 */\n/* 顶部header */\n/* 造型 */\n[class*=labeled-icon-button_edit-field-title] {\n  font-size: 0.80rem;\n}\n[class*=paint-editor_bitmap-button] {\n  font-size: 0.85rem;\n}\n/* 声音 */\n[class*=sound-editor_trim-button] {\n  font-size: 0.80rem;\n}\n[class*=sound-editor_effect-button] {\n  font-size: 0.80rem;\n}", ""]);

// exports
